import { getImage } from 'gatsby-plugin-image';
import { ITwoColumnDynamicForm } from './TwoColumnDynamicForm';
import { IDynamicForm } from '../DynamicForm/IDynamicFormTypes';
import { ITwoColumnFormTextContext } from '../TwoColumnFormText/TwoColumnFormText';

export const twoColumnDynamicFormTransformer = (
    node
): ITwoColumnDynamicForm => {
    const dynamicFormData = node?.relationships?.field_dynamic_form_column;
    return {
        theme: node?.field_theme,
        formCol: {
            id: dynamicFormData?.id,
            formHeadingData: {
                formHeadingText: dynamicFormData?.field_heading ?? undefined,
                formHeadingTag:
                    dynamicFormData?.field_heading_tag_select ?? `h1`,
                formHeadingSubtitle: dynamicFormData?.field_subtitle,
                align: node.relationships?.field_dynamic_form_column?.field_lc_align?.toLowerCase(),
                static: node.relationships?.field_dynamic_form_column
                    ?.field_toggle_static,
            },
            node: dynamicFormData?.relationships?.field_form?.elements,
            submissionUrl:
                dynamicFormData?.relationships?.field_form.handlers?.remote_post
                    ?.settings?.completed_url,
            dynamicFormID: ``,
            disclaimer: dynamicFormData?.field_disclaimer?.value,
            successPageUrl: dynamicFormData?.field_success_page_url,
        } as IDynamicForm,
        contextCol: {
            eyebrow:
                node?.relationships?.field_form_context_column
                    ?.field_eyebrow_text,
            heading:
                node?.relationships?.field_form_context_column?.field_heading,
            headingOption:
                node?.relationships?.field_form_context_column
                    ?.field_heading_option,
            contextCopy:
                node?.relationships?.field_form_context_column
                    ?.field_body_copy_content?.value,
            contextMediaData: {
                contextMedia:
                    node?.relationships?.field_form_context_column
                        ?.relationships?.field_media_content?.relationships
                        ?.field_media_image?.localFile,
                contextMediaMobile:
                    node?.relationships?.field_form_context_column
                        ?.field_mobile_image_display,
                contextMediaAlt:
                    node?.relationships?.field_form_context_column
                        ?.relationships?.field_media_content?.field_media_image
                        ?.alt,
            },
            formIcons:
                node?.relationships?.field_form_context_column?.relationships?.field_form_icons?.map(
                    (icon) => {
                        if (
                            icon.field_content_text?.value ||
                            icon.relationships?.field_icon_img
                        ) {
                            return {
                                iconAltTag: icon.field_alt_tag,
                                iconText: icon.field_content_text?.value,
                                iconImg: icon.relationships?.field_icon_img
                                    ? {
                                          blueLine: getImage(
                                              icon.relationships?.field_icon_img
                                                  ?.relationships
                                                  ?.field_image_dark_blue_line
                                                  ?.localFile
                                          ),
                                          whiteSticker: getImage(
                                              icon.relationships?.field_icon_img
                                                  ?.relationships
                                                  ?.field_image_white_sticker
                                                  ?.localFile
                                          ),
                                          blueSticker: getImage(
                                              icon.relationships?.field_icon_img
                                                  ?.relationships
                                                  ?.field_image_dark_blue_sticker
                                                  ?.localFile
                                          ),
                                      }
                                    : undefined,
                            };
                        } else return {};
                    }
                ),
            formQuotes:
                node?.relationships?.field_form_context_column?.relationships?.field_form_quote?.map(
                    (quote) => {
                        if (quote.field_content_text?.value) {
                            return {
                                quoteText: quote.field_content_text?.value,
                                speaker: quote.field_quote_speaker,
                            };
                        } else return {};
                    }
                ),
            conclusion:
                node?.relationships?.field_form_context_column
                    ?.field_content_text?.value,
        } as ITwoColumnFormTextContext,
    };
};
